<template>
 <b-carousel
    class="detection-images"
      :controls="files.length > 1"
      :indicators="files.length > 1"
      background="#ababab"
      img-width="300"
      img-height="300"
      style="text-shadow: 1px 1px 2px #000;"
      :interval="0"
    >
      <b-carousel-slide v-for="file in files" :key="file.id">
        <template #img>
        <FilePreview   :file="file" :set_id="set_id"
          @image_click="$emit('image_click', file)"
          :can_click_image="can_click_image"
          :image_type="image_type" />
          </template>
          </b-carousel-slide>
      </b-carousel>
</template>

<script>
import FilePreview from '@/views/Shared/FilePreview.vue';

export default {
  components: {
    FilePreview,
  },
  props: {
    files: {
      type: Array,
      required: true,
    },
    set_id: {
      type: Number,
      required: true,
    },
    image_type: {
      type: String,
      required: true,
      default: 'sample',
    },
    can_click_image: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
<style lang="scss">
.detection-images {
  max-width: 300px;

  .carousel-control-prev,
  .carousel-control-next {
    top: 50%;
    margin: -20px 0 0;
    background: #333;
    height: 40px;
    width: 40px;
  }
}

.carousel-indicators li {
  width: 6px;
  height: 6px;
  border-radius: 100%;
  box-shadow: 0 0px 2px rgba(0, 0, 0, 0.5);
  border: none
}
</style>
